var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-0 mt-2 ma-0",attrs:{"id":_vm.url}})}
var staticRenderFns = []

export { render, staticRenderFns }